export default function scrollLeft($el) {
  const $container = $el.parent();

  $container.animate({
    scrollLeft: $el.offset().left - ($el.width() / 2) - ($container.width() / 2),
  });
}
